import { Col, Form, Input, Modal, Row } from 'antd';
import { ml } from 'src/_shared/services/utils.js';
import { PageItem } from 'src/manageJobs/addJobModal/pages/';

const { TextArea } = Input;

function AddJobForm({
	currentUser,
	allMultiLingualData,
	handleChange,
	addPosition,
	editedDescription,
	toggleNewPosition,
	handleCancel,
	submitNewPosition,
}) {
	const [form] = Form.useForm();

	const handleModalCancel = () => {
		form.resetFields();
		toggleNewPosition();
		handleCancel();
	};

	const handleModalOk = async () => {
		try {
			const values = await form.validateFields();
			await submitNewPosition();
			form.resetFields();
		} catch (error) {
			console.log('Validation failed:', error);
		}
	};

	// Custom validator for start date
	const validateStartDate = (_, value) => {
		return new Promise((resolve, reject) => {
			const endDate = form.getFieldValue('endDate');

			if (value && endDate && value > endDate) {
				reject(new Error('Start Date must be before End Date'));
			} else {
				resolve();
			}
		});
	};

	// Custom validator for end date
	const validateEndDate = (_, value) => {
		return new Promise((resolve, reject) => {
			const startDate = form.getFieldValue('startDate');

			if (value && startDate && value < startDate) {
				reject(new Error('End Date must be after Start Date'));
			} else {
				resolve();
			}
		});
	};

	// Handle form value changes to trigger cross-field validation
	const onValuesChange = (changedValues, allValues) => {
		// Re-validate the other date field when one date changes
		if (changedValues.startDate && allValues.endDate) {
			form.validateFields(['endDate']);
		}
		if (changedValues.endDate && allValues.startDate) {
			form.validateFields(['startDate']);
		}
	};

	return (
		<Modal
			centered
			open={addPosition}
			okText="Submit"
			title="Add Job"
			onCancel={handleModalCancel}
			onOk={handleModalOk}
		>
			<Form form={form} onValuesChange={onValuesChange} layout="vertical">
				<div>
					<Row gutter={12}>
						<Col sm={12} xs={24}>
							<div className="custom-form-group">
								<PageItem
									title={ml('Position', currentUser, allMultiLingualData)}
								>
									<Form.Item
										name="position"
										rules={[
											{
												required: true,
												whitespace: true,
												message: 'Please enter your position!',
											},
										]}
									>
										<Input
											id="editedPosition"
											name="editedPosition"
											placeholder={ml(
												'Position',
												currentUser,
												allMultiLingualData
											)}
											className="custom-input"
											onChange={handleChange('editedResumePosition')}
										/>
									</Form.Item>
								</PageItem>
							</div>
						</Col>
						<Col sm={12} xs={24}>
							<div className="custom-form-group">
								<PageItem
									title={ml('Company', currentUser, allMultiLingualData)}
								>
									<Form.Item
										name="company"
										rules={[
											{
												required: true,
												whitespace: true,
												message: 'Please enter your company!',
											},
										]}
									>
										<Input
											name="editedOrg"
											placeholder="Organization"
											className="custom-input"
											onChange={handleChange('editedOrg')}
										/>
									</Form.Item>
								</PageItem>
							</div>
						</Col>
					</Row>

					<Row gutter={12}>
						<Col sm={12} xs={24}>
							<div className="custom-form-group">
								<PageItem
									title={ml('Start Date', currentUser, allMultiLingualData)}
								>
									<Form.Item
										name="startDate"
										rules={[
											{
												required: true,
												message: 'Please enter your start date!',
											},
											{
												validator: validateStartDate,
											},
										]}
									>
										<Input
											name="startDate"
											placeholder={ml(
												'Start Date',
												currentUser,
												allMultiLingualData
											)}
											type="date"
											className="custom-input"
											onChange={handleChange('editedStartDate')}
										/>
									</Form.Item>
								</PageItem>
							</div>
						</Col>
						<Col sm={12} xs={24}>
							<div className="custom-form-group">
								<PageItem
									title={ml('End Date', currentUser, allMultiLingualData)}
								>
									<Form.Item
										name="endDate"
										rules={[
											{
												required: false,
											},
											{
												validator: validateEndDate,
											},
										]}
									>
										<Input
											name="endDate"
											placeholder={ml(
												'End Date',
												currentUser,
												allMultiLingualData
											)}
											type="date"
											className="custom-input"
											onChange={handleChange('editedEndDate')}
										/>
									</Form.Item>
								</PageItem>
							</div>
						</Col>
					</Row>

					<Row>
						<div className="custom-form-group mb-0 w-100">
							<PageItem
								title={ml('Description', currentUser, allMultiLingualData)}
							>
								<Form.Item name="description">
									<TextArea
										autoSize={{ minRows: 2, maxRows: 6 }}
										name="editedDescription"
										placeholder={ml(
											'Description',
											currentUser,
											allMultiLingualData
										)}
										value={editedDescription}
										className="custom-input"
										onChange={handleChange('editedDescription')}
									/>
								</Form.Item>
							</PageItem>
						</div>
					</Row>
				</div>
			</Form>
		</Modal>
	);
}

export default AddJobForm;
